"use strict";

;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled && !Flix.ads.isOrganic(); // do not show for organic users
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }

    // mobile only
    if (!FlixUtils.isMobile()) {
      return;
    }
    var el = createElement('div');
    if (!el) {
      return;
    }
    el.dataset.nosnippet = true;
    el.innerHTML = '<div class="ad-logo">Ad</div>';
    document.querySelector('body').appendChild(el);
    FlixUtils.renderBannerAd(getZoneId(), el, 'eas6a97888e14', 'ad_error_im');
  }
  ;
  function getZoneId() {
    return Flix.isTna() ? '3071054' : '5649560';
  }
})();